import yahooSrc from '@corbado/shared-ui/assets/yahoo.svg';
import React from 'react';
import { Icon } from './Icon';
export const YahooIcon = props => {
    return (React.createElement(Icon, { src: yahooSrc, ...props }));
};
